import React from "react";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Button } from "react-bootstrap";
import MatrixRender from "../../lib/matrix-render";

const CmModal = ({ data }) => {
  const { newsletterTitle, buttonText, newsletterContent } = data;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        className="cm-modal-btn button-primary rounded-0"
        onClick={handleShow}
      >
        {buttonText}
      </Button>

      <Modal className="cm-modal rounded-0" show={show} onHide={handleClose}>
        <Modal.Header closeButton className="rounded-0 border-0">
          <Modal.Title>{newsletterTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: newsletterContent
            }}
          ></div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button className="button-primary rounded-0" onClick={handleClose}>
            Close
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

MatrixRender.ComponentsByClass(".cm-modal-react", "cmModalDataCMS", CmModal);

export default CmModal;
